import type { ApolloCache } from '@apollo/client'

import type { SavedView } from './useSavedViewsQuery'
import { SavedViewsQuery } from '../graphql/SavedViewsQuery'

/**
 * Update the cached SavedViews list for the given org via a pure transform.
 * No-op when the cached entry is missing — callers can rely on a refetch to
 * repopulate the list.
 */
export function writeSavedViewsList(
  cache: ApolloCache,
  organizationId: string,
  transform: (current: SavedView[]) => SavedView[],
): void {
  const existing = cache.readQuery({
    query: SavedViewsQuery,
    variables: { input: { organizationId } },
  })
  if (!existing) return

  cache.writeQuery({
    query: SavedViewsQuery,
    variables: { input: { organizationId } },
    data: {
      savedViews: {
        savedViews: transform(existing.savedViews.savedViews),
      },
    },
  })
}
